import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './CompaniesWorkflowStatusQuery.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CompaniesWorkflowStatusQueryQueryVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
}>;


export type CompaniesWorkflowStatusQueryQuery = (
  { __typename?: 'Query' }
  & { company?: Types.Maybe<(
    { __typename?: 'Company' }
    & Pick<Types.Company, 'id' | 'inPublicationWorkflow'>
  )> }
);



/**
 * __useCompaniesWorkflowStatusQueryQuery__
 *
 * To run a query within a React component, call `useCompaniesWorkflowStatusQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesWorkflowStatusQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesWorkflowStatusQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompaniesWorkflowStatusQueryQuery(baseOptions: Apollo.QueryHookOptions<CompaniesWorkflowStatusQueryQuery, CompaniesWorkflowStatusQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesWorkflowStatusQueryQuery, CompaniesWorkflowStatusQueryQueryVariables>(Operations.CompaniesWorkflowStatusQuery, options);
      }
export function useCompaniesWorkflowStatusQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesWorkflowStatusQueryQuery, CompaniesWorkflowStatusQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesWorkflowStatusQueryQuery, CompaniesWorkflowStatusQueryQueryVariables>(Operations.CompaniesWorkflowStatusQuery, options);
        }
export type CompaniesWorkflowStatusQueryQueryHookResult = ReturnType<typeof useCompaniesWorkflowStatusQueryQuery>;
export type CompaniesWorkflowStatusQueryLazyQueryHookResult = ReturnType<typeof useCompaniesWorkflowStatusQueryLazyQuery>;
export type CompaniesWorkflowStatusQueryQueryResult = Apollo.QueryResult<CompaniesWorkflowStatusQueryQuery, CompaniesWorkflowStatusQueryQueryVariables>;